// extracted by mini-css-extract-plugin
export default {"card":"A0-z"};